var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsPlus2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00C1DE",
    d: "M13 11h7a1 1 0 010 2h-7v7a1 1 0 01-2 0v-7H4a1 1 0 010-2h7V4a1 1 0 012 0v7z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMCAwSDI0VjI0SDB6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMzOSAtMTI1KSB0cmFuc2xhdGUoMTIwMCAxMTMpIHRyYW5zbGF0ZSgxMzkgMTIpIi8+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iIzAwQzFERSIgZD0iTTEzIDExaDdjLjU1MiAwIDEgLjQ0OCAxIDFzLS40NDggMS0xIDFoLTd2N2MwIC41NTItLjQ0OCAxLTEgMXMtMS0uNDQ4LTEtMXYtN0g0Yy0uNTUyIDAtMS0uNDQ4LTEtMXMuNDQ4LTEgMS0xaDdWNGMwLS41NTIuNDQ4LTEgMS0xczEgLjQ0OCAxIDF2N3oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzM5IC0xMjUpIHRyYW5zbGF0ZSgxMjAwIDExMykgdHJhbnNsYXRlKDEzOSAxMikiLz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgIconsPlus2 as ReactComponent };